/**
 * Catalog Types & Utilities
 *
 * Shared types and helper functions for catalog components.
 */

import type { SupplierCatalogItemWithDetails, RawProductWithRelations } from '@bstock/shared';

/**
 * Group catalog items by raw product
 */
export interface ProductGroup {
  rawProduct: {
    id: string;
    name: string;
    sku: string;
    recipeUnit: { id: string; code: string; symbol: string };
  };
  items: SupplierCatalogItemWithDetails[];
}

/**
 * State for a new item being added
 */
export interface NewItemState {
  rawProduct: RawProductWithRelations;
  packagingId: string | null;
  conversionToRecipeUnit: string;
  priceExclTax: string;
  supplierRef: string;
}

/**
 * Group catalog items by raw product
 */
export function groupItemsByProduct(items: SupplierCatalogItemWithDetails[]): ProductGroup[] {
  const groups = new Map<string, ProductGroup>();

  for (const item of items) {
    const productId = item.rawProduct.id;
    if (!groups.has(productId)) {
      groups.set(productId, {
        rawProduct: item.rawProduct,
        items: [],
      });
    }
    groups.get(productId)!.items.push(item);
  }

  // Sort groups by product name
  return Array.from(groups.values()).sort((a, b) =>
    a.rawProduct.name.localeCompare(b.rawProduct.name)
  );
}
